

























import { Component, Prop, Vue, Watch, Emit } from "vue-property-decorator";
import ButtonComponent from "@/components/common/parts/ButtonComponent.vue";
import { postEquipmentsMeasurementApi } from "@/typescript/api_client/emesh_api/equipments/equipments_measurement_api";

@Component({
  components: {
    ButtonComponent
  }
})
export default class GraphCommentComponent extends Vue {
  @Prop({
    default: false
  })
  show!: boolean;

  @Prop({
    default: 0
  })
  x!: number;

  @Prop({
    default: 0
  })
  y!: number;

  @Prop()
  registCommentData!: { equipment_id: string; start_date: string };

  innerShow = this.show;
  innerValue: string = "";

  @Emit("showChange")
  showChange(value: boolean) {
    return value;
  }

  @Emit("valueChange")
  change(value: string) {
    return value;
  }

  @Watch("innerShow")
  onInnerShowChange(showValue: boolean) {
    this.showChange(showValue);
  }

  @Watch("show")
  onShowChange(showValue: boolean) {
    this.innerShow = showValue;
  }

  @Watch("innerValue")
  onInnerValueChange(newValue: string) {
    this.change(newValue);
  }

  @Emit()
  addComment() {
    postEquipmentsMeasurementApi({
      equipment_id: this.registCommentData.equipment_id,
      start_date: this.registCommentData.start_date,
      comment: this.innerValue
    });
    this.innerValue = "";
    return event;
  }

  get style(): object {
    return {
      display: this.innerShow == true ? "flex" : "none",
      left: this.x + "px",
      top: this.y + "px"
    };
  }

  clickCancel() {
    this.innerShow = false;
  }
}
